module.exports = require("./../../_gen/starling/filters/GlowFilter");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/filters/GlowFilter.js
// module id = 207
// module chunks = 0